export default "# who am i\r\n\r\n## developer";


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader/dist/cjs.js!./src/blog/1_readme.md
// module id = InWD
// module chunks = 1